import { render, staticRenderFns } from "./SendFileUpload.vue?vue&type=template&id=7248b963&scoped=true&"
import script from "./SendFileUpload.vue?vue&type=script&lang=js&"
export * from "./SendFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./SendFileUpload.vue?vue&type=style&index=0&id=7248b963&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7248b963",
  null
  
)

export default component.exports